import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { BRAND } from '../data/mock';

const Header = () => {
  const { language, toggleLanguage } = useLanguage();
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = {
    es: [
      { label: 'Inicio', href: '#hero' },
      { label: 'Servicios', href: '#services' },
      { label: 'Paquetes', href: '#packages' },
      { label: 'Valores', href: '#values' },
      { label: 'Blog', href: '/blog', isRoute: true },
      { label: 'Contacto', href: '#contact' }
    ],
    en: [
      { label: 'Home', href: '#hero' },
      { label: 'Services', href: '#services' },
      { label: 'Packages', href: '#packages' },
      { label: 'About', href: '#values' },
      { label: 'Blog', href: '/blog', isRoute: true },
      { label: 'Contact', href: '#contact' }
    ]
  };

  const resolveHref = (item) => {
    if (item.isRoute) {
      return item.href;
    }

    return location.pathname === '/' ? item.href : `/${item.href}`;
  };

  return (
    <header className={`header ${scrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <div className="header-content">
          <div className="logo" data-testid="site-logo-mark">
            <img src={BRAND.logoUrl} alt={BRAND.name} />
          </div>
          
          <nav className={`nav ${mobileMenuOpen ? 'mobile-open' : ''}`}>
            {navItems[language].map((item) => (
              <a
                key={item.href}
                href={resolveHref(item)}
                onClick={() => setMobileMenuOpen(false)}
                data-testid={`header-nav-${item.label.toLowerCase().replace(/[^a-z]+/g, '-')}`}
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="header-actions">
            <button 
              className="lang-toggle" 
              onClick={toggleLanguage}
              aria-label="Toggle language"
              data-testid="language-toggle-button"
            >
              {language === 'es' ? 'EN' : 'ES'}
            </button>
            
            <button 
              className="mobile-menu-toggle"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              aria-label="Toggle menu"
              data-testid="mobile-menu-toggle-button"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
